












import Vue, { PropType } from 'vue'
import XIcon, { IconProps } from '@/components/atoms/Icon/XIcon.vue'

type Props = {
  value: string | number
  completed: boolean
  current: boolean
  completedIcon: IconProps
}

export default Vue.extend<{}, {}, {}, Props>({
  components: { XIcon },
  name: 'Step',
  props: {
    value: {
      type: [String, Number],
      required: true,
      default: () => 1,
    },
    completed: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    current: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    completedIcon: {
      type: Object as PropType<IconProps>,
      required: false,
      default: () => ({ name: 'mdi-check', type: 'material' }),
    },
  },
})
